var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16651 7.37525H8.24984M4.16651 4.45858H6.20818M7.47401 11.1027C9.91468 10.9412 11.8583 8.9695 12.0182 6.49441C12.0491 6.01025 12.0491 5.50858 12.0182 5.02441C11.8583 2.54991 9.91468 0.579414 7.47401 0.416664C6.63103 0.361112 5.78532 0.361112 4.94234 0.416664C2.50168 0.578831 0.558009 2.54991 0.398176 5.025C0.367275 5.51451 0.367275 6.00548 0.398176 6.495C0.456509 7.39625 0.854926 8.231 1.32451 8.93566C1.59693 9.42858 1.41726 10.044 1.13318 10.5824C0.929009 10.9703 0.826342 11.164 0.908592 11.304C0.990259 11.444 1.17401 11.4487 1.54093 11.4574C2.26718 11.4749 2.75659 11.2696 3.14509 10.9832C3.36501 10.8204 3.47526 10.7393 3.55109 10.73C3.62693 10.7207 3.77684 10.7825 4.07551 10.905C4.34384 11.0158 4.65593 11.0841 4.94176 11.1033C5.77301 11.1582 6.64159 11.1582 7.47459 11.1033",
    stroke: "#262F5F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSms);
export default __webpack_public_path__ + "static/media/send-sms.1d979d03f159bb6f7b88dbff2a1a2ce3.svg";
export { ForwardRef as ReactComponent };